<template>
  <div
    :style="cardStyle"
    class="card"
    @wheel.stop.prevent  ="wheelHandler"
  >
    <div
      :style="titleStyle"
      class="title"
      @mousedown.left="mousedownHandler"
    >
      {{card.title}}
    </div>
    <div
      class="body"
    >
      {{card.body}}
    </div>
  </div>
</template>

<style scoped>
.card {
  position         : absolute;
  user-select      : none;
  transform        : scale(var(--scale));
  background-color : var(--body-color);
  z-index          : 400;
  display          : none;
}
.title {
  font-weight      : bolder;
  position         : relative;
  background-color : var(--title-color);
  width            : 100%;
  height           : 30px;
}
.body {
  max-height       : 100px;
  position         : relative;
  background-color : yellow;
}
</style>

<script lang="">
export default {
  // Options / Data
  data () {
    return {
      mousedownX : 0,
      mousedownY : 0,
      card       : {
        titleColor : 'green',
        bodyColor  : 'gray',
        top        : 100,
        left       : 100,
        width      : 400,
        height     : 300,
        scale      : 100,
        type       : 'card',
        title      : 'test',
        body       : '祇園精舎の鐘の声 諸行無常の響あり 沙羅双樹の花の色 盛者必衰の理をあらわす おごれるものも久しからず ただ春の夢のごとし'
      }
    }
  },
  props    : [],
  computed : {
    cardStyle () {
      return {
        width          : this.card.width + 'px',
        height         : 'auto',
        top            : this.card.top + 'px',
        left           : this.card.left + 'px',
        '--scale'      : this.card.scale / 100,
        '--body-color' : this.card.bodyColor
      }
    },
    titleStyle () {
      return {
        '--title-color': this.card.titleColor
      }
    }
  },
  methods: {
    mousedownHandler (e) {
      this.mousedownX = e.offsetX
      this.mousedownY = e.offsetY
      this.$parent.$el.addEventListener('mousemove', this.mousemoveHandler, false)
      this.$parent.$el.addEventListener('mouseup', this.mouseupHandler, false)
      this.$eventHub.$emit('object-drag', true)
    },
    mouseupHandler (e) {
      this.$parent.$el.removeEventListener('mousemove', this.mousemoveHandler, false)
      this.$parent.$el.removeEventListener('mouseup', this.mouseupHandler, false)
      this.$eventHub.$emit('object-drag', false)
    },
    mousemoveHandler (e) {
      console.log(e.offsetX, this.mousedownX, this.card.scale)
      this.card.top = e.offsetY - this.mousedownY
      this.card.left = e.offsetX - this.mousedownX
    },
    wheelHandler (e) {
      this.card.scale = this.card.scale - e.deltaY / Math.abs(e.deltaY) * (this.card.scale / 10)
    }
  }// ,
  // watch: {},
  // Options / DOM
  // el () {},
  // replace: true,
  // template: '',
  // Options / Lifecycle Hooks
  // init () {},
  // crated () {},
  // beforeCompile () {},
  // compiled () {},
  // ready () {},
  // attached () {},
  // detached () {},
  // beforeDestroy () {},
  // destroyed () {},
  // Options / Assets
  // directives: {},
  // elementDirectives: {},
  // filters: {},
  // components: {},
  // transitions: {},
  // partials: {},
  // Options / Misc
  // parent: null,
  // events: {},
  // mixins: [],
  // name: ''
}
</script>



// WEBPACK FOOTER //
// src/components/object/content/card.vue